import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { STATUS_OBJECT } from 'src/app/dummy/status';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { PrintService } from 'src/app/services/print.service';
import { TABS } from 'src/app/dummy/tab';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { ResourceStore } from 'src/app/stores/resources/resource.store';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { AddTrainingTutorComponent } from '../add-training-tutor/add-training-tutor.component';
import { AddTrainingStudentComponent } from '../add-training-student/add-training-student.component';

@Component({
  selector: 'app-training-register-test',
  templateUrl: './training-register-test.component.html',
  styleUrls: ['./training-register-test.component.scss']
})
export class TrainingRegisterTestComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  tabs = TABS.REGISTER_TEST;
  DISPLAY_STATUS_KEY: any;

  constructor(
    private route: ActivatedRoute,
    public store: ResourceStore,
    private auth: AuthStore,
    public ps: PrintService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
  ) { }

  async ngOnInit() {
    this.DISPLAY_STATUS_KEY = STATUS_OBJECT.submitted;
    const { selectedCompanyKey } = this.auth;
    this.store.fetchData(COLLECTION_NAME.STUDENTS, this.DISPLAY_STATUS_KEY.key, selectedCompanyKey,null,null,null,true)
  }

  create(item?: any) {
    const dialogRef = this.dialog.open(AddTrainingStudentComponent, {
      data: { STUDENT: item || null,TESTING_ACCOUNT:true },
      panelClass: "register-test-overlay-panel",
      width: "35vw",
      height: "100vh",
      disableClose: true,
      role: "dialog"
    });
    dialogRef.updatePosition({ top: "0", right: "0", bottom: "0" });
    dialogRef.afterClosed().subscribe(result => { });
  }

  delete(item: any) {
    let dialogRef = this.dialog.open(DeleteComponent, {
      data: item,
      panelClass: 'cs-overlay-panel',
      width: '',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.store.delete(COLLECTION_NAME.STUDENTS, item, (success) => {
          if (success) {
            this.snackBar.open("Student has been deleted successful.", "Done", { duration: 2500 });
          }
        })
      }
    });
  }

}
